<template>
  <SogCard>
    <SogCardActions :is-toolbar="true">
      <SogCardActionButton
        mdi-icon="mdi-cart-arrow-down"
        tooltip="In den Einkaufswagen legen"
        @click="onAddExportBlanks"
      />
      <SogCardActionButton
        mdi-icon="mdi-list-box"
        tooltip="Liste"
        @click="onStoreExportBlank"
      />
    </SogCardActions>
    <SogCardContent>
      {{ _current.shoppingCartItem.productPrice?.productTypeId }}
      <ExportBlankFormComponent ref="_exportBlankForm" />
    </SogCardContent>
  </SogCard>
</template>

<script setup lang="ts">

import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import ExportBlankFormComponent from "@/modules/ShoppingCart/components/ExportBlankFormComponent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import {storeToRefs} from "pinia";
import {ref} from "vue";
import {fillNumberWithZeros} from "@/shared/utils/NumberUtils";
import notificationService from "@/shared/services/NotificationService";

const _shoppingCartStore = useShoppingCartStore();
const {currentItem: _current} = storeToRefs(_shoppingCartStore);
const _exportBlankForm = ref<InstanceType<typeof ExportBlankFormComponent> | null>(null);

async function onAddExportBlanks() {
  if(!_exportBlankForm.value)
    return
  const t_result = _exportBlankForm.value.getResults();
  if (_current.value.shoppingCartItem.productPrice?.productTypeId === "ExportBlank") {
    _current.value.shoppingCartItem.count = t_result.count;
    _current.value.shoppingCartItem.digitCount = t_result.digitCount;
    _current.value.shoppingCartItem.prefix = t_result.prefix;
    _current.value.shoppingCartItem.startNumber = t_result.startNumber;
    _current.value.shoppingCartItem.insuranceExportBlanks.length = 0;

    await _shoppingCartStore.addItem();
    return;
  }
  else if (_current.value.shoppingCartItem.productPrice?.productTypeId === "Zoll") {
    const t_start = t_result.prefix + fillNumberWithZeros(t_result.startNumber, t_result.digitCount)
    const t_end = t_result.prefix + fillNumberWithZeros((t_result.startNumber + t_result.count - 1), t_result.digitCount)

    const t_array = _shoppingCartStore.currentShoppingCart.storeExportBlank.filter(t => t.blankNumber && t.blankNumber >= t_start && t.blankNumber <= t_end)

    if (t_array.length !== t_result.count) {
      notificationService.error("Nicht alle Karten sind in Bestand");
      return
    }
    t_array.forEach(t => {
      _shoppingCartStore.addInsuranceExportBlank(t)
    });

    console.log(_shoppingCartStore.currentShoppingCart)

    await _shoppingCartStore.addStoreExportBlanks();
  }
}

async function onStoreExportBlank() {
  await _shoppingCartStore.navigate("storeexportblank")
  return;
}


</script>

<style scoped>

</style>
